import { normalize } from "normalizr";
import { camelizeKeys } from "humps";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "../../../../actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import schemas from "../../../../utils/schemas";
import FolderApi from "../../list/api";
import * as actionTypes from "../../list/actionTypes";
import { getResponsibleFolders } from "./selectors";
import * as eventTypes from "./eventTypes";

export const loadResponsibleFoldersKey = (filters, pageSize) => {
  return JSON.stringify({ ...filters, pageSize });
};

export function loadFolders(filters, page, pageSize) {
  return async (dispatch, getState) => {
    const { loading, loaded } = getResponsibleFolders(filters, page, pageSize, getState());
    let shouldCallApi = !loaded && !loading;
    if (!shouldCallApi) return;

    const key = loadResponsibleFoldersKey(filters, pageSize);
    dispatch({ type: actionTypes.LOAD_RESPONSIBLE_FOLDERS_STARTED, key, page, pageSize });

    try {
      const response = await dispatch(sendHttpRequest(FolderApi.getFolders(filters, page, pageSize)));
      const camelizedJson = camelizeKeys(response.values);
      const payload = Object.assign({}, normalize(camelizedJson, schemas.responsibleChangeFolders));

      dispatch({
        type: actionTypes.LOAD_RESPONSIBLE_FOLDERS_SUCCEEDED,
        key,
        page,
        totalCount: response.totalCount,
        totalPages: response.totalPages,
        ...payload
      });
    } catch (error) {
      console.log(error);
      dispatch({ type: actionTypes.LOAD_RESPONSIBLE_FOLDERS_FAILED, key, page, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function setResponsibleOnFolders(folders, responsibleId, responsibleName) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_RESPONSIBLE_FOLDERS_STARTED,
      payload: folders,
      responsibleId: responsibleId,
      responsibleName: responsibleName
    });
    let event = await dispatch(
      sendHttpCommandAndWaitForEvent(
        FolderApi.updateResponsibleOnFolders(folders, responsibleId, responsibleName),
        "updateFoldersResponsible",
        [eventTypes.FOLDERS_RESPONSIBLE_UPDATED]
      )
    );
    if (event.ok) {
      dispatch({
        type: actionTypes.UPDATE_RESPONSIBLE_FOLDERS_SUCCEEDED,
        payload: folders,
        responsibleId,
        responsibleName
      });
    } else {
      dispatch({ type: actionTypes.UPDATE_RESPONSIBLE_FOLDERS_FAILED, payload: { folders, error: event } });
    }
  };
}

export function refreshResponsibleFolders(filters, pageSize) {
  return dispatch => {
    const key = loadResponsibleFoldersKey(filters, pageSize);
    dispatch({ type: actionTypes.REFRESH_RESPONSIBLE_FOLDERS, key });
  };
}
